import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Profile.css";

export default function Profile() {
    const navigate = useNavigate();

    const [user, setUser] = useState({
        username: "",
        role: ""
    });

    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [message, setMessage] = useState("");
    const [error, setError] = useState("");

    const API_URL = process.env.REACT_APP_API_URL;

    useEffect(() => {
        const token = localStorage.getItem("token");

        if (!token) {
            navigate("/login", { replace: true });
            return;
        }

        setUser({
            username: localStorage.getItem("username") || "",
            role: (localStorage.getItem("role") || "").toLowerCase()
        });
    }, [navigate]);

    const handlePasswordUpdate = async (e) => {
        e.preventDefault();

        setMessage("");
        setError("");

        if (!password || !confirmPassword) {
            setError("Please fill in all fields");
            return;
        }

        if (password.length < 6) {
            setError("Password must be at least 6 characters");
            return;
        }

        if (password !== confirmPassword) {
            setError("Passwords do not match");
            return;
        }

        try {

            const token = localStorage.getItem("token");

            const res = await fetch(`${API_URL}/api/user/updateUser`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`
                },
                body: JSON.stringify({
                    password
                })
            });

            const data = await res.json();

            if (!res.ok) {
                setError(data.error || "Failed to update password");
                return;
            }

            setMessage("Password updated successfully");
            setPassword("");
            setConfirmPassword("");

        } catch (err) {
            console.error(err);
            setError("Server error updating password");
        }
    }

    return (
        <div className="profile-container">
            <div className="profile card">

                <h2 className="profile-header">Profile</h2>

                <div className="profile-info">
                    <p>Hello, {user.username}</p>
                    <p>Role: {user.role}</p>
                </div>

                <hr />

                <h3>Update Password</h3>
                <form onSubmit={handlePasswordUpdate} className="profile-form">

                    <div className="form-group">
                        <label>New Password</label>
                        <input
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            placeholder="Enter new password"
                            required
                        />
                    </div>

                    <div className="form-group">
                        <label>Confirm Password</label>
                        <input
                            type="password"
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                            placeholder="Confirm new password"
                            required
                        />
                    </div>

                    {error && <p className="error">{error}</p>}
                    {message && <p className="success">{message}</p>}

                    <button type="submit" className="btn-primary">
                        Update Password
                    </button>
                </form>
            </div>
        </div>
    )
}
